import Tabs from "@/shared/data-display/tabs";
import { ReactNode } from "react";
import { useTranslations } from "use-intl";
import { DYNAMIC_PROCESS_TABS } from "./dynamic-process-tabs-enum";
import { TabsContextProvider, useTabs } from "./dynamic-process-tabs-context";
import { DynamicProcessTabsButton } from "./dynamic-process-tabs-button";
import { useModelId } from "../../model/model-id/use-model-id";

export function DynamicProcessTabs({
  base,
  path,
  templates,
  dynamicAttribute,
}: {
  base: ReactNode;
  path: ReactNode;
  templates: ReactNode;
  dynamicAttribute: ReactNode;
}) {
  const t = useTranslations("DynamicProcesses");
  const { step, setStep } = useTabs();
  const { modelId } = useModelId();

  return (
    <Tabs
      activeKey={step}
      onChange={(key) => setStep(key as DYNAMIC_PROCESS_TABS)}
      items={[
        {
          key: DYNAMIC_PROCESS_TABS.BASE_KEY,
          label: t("DYNAMIC_PROCESS_TABS_GENERAL_TAB"),
          children: base,
          forceRender: true,
          disabled: !modelId && step !== DYNAMIC_PROCESS_TABS.BASE_KEY,
        },
        {
          key: DYNAMIC_PROCESS_TABS.PATH_KEY,
          label: t("DYNAMIC_PROCESS_TABS_PATH_TAB"),
          children: path,
          forceRender: true,
          disabled: !modelId && step !== DYNAMIC_PROCESS_TABS.PATH_KEY,
        },
        {
          key: DYNAMIC_PROCESS_TABS.TEMPLATES_KEY,
          label: t("DYNAMIC_PROCESS_TABS_TEMPLATES_TAB"),
          children: templates,
          forceRender: true,
          disabled: !modelId && step !== DYNAMIC_PROCESS_TABS.TEMPLATES_KEY,
        },
        {
          key: DYNAMIC_PROCESS_TABS.DYNAMIC_ATTRIBUTES_KEY,
          label: t("DYNAMIC_PROCESS_TABS_DYNAMIC_ATTRIBUTES_TAB"),
          children: dynamicAttribute,
          forceRender: true,
          disabled:
            !modelId && step !== DYNAMIC_PROCESS_TABS.DYNAMIC_ATTRIBUTES_KEY,
        },
      ]}
    />
  );
}

DynamicProcessTabs.Provider = TabsContextProvider;
DynamicProcessTabs.useTabs = useTabs;
DynamicProcessTabs.ENUM = DYNAMIC_PROCESS_TABS;
DynamicProcessTabs.Button = DynamicProcessTabsButton;
